import React from 'react'
import TranslationCont from '../General/TranslationCont'

const MovieGenresAccess = ({genres}) => {
    if(!genres || !genres[0]) {
        return ''
    }

    return (
        <>
            <dt><TranslationCont id="genres" after=':'>Genres</TranslationCont></dt>
            {genres.map((genre, index) => <dd key={index}>{genre}</dd>)}
        </>
    )

}

export default MovieGenresAccess